import { FC, ReactNode } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { IS_POSTHOG_CONFIGURED, POSTHOG_PROJECT_API_KEY, POSTHOG_PROVIDER_OPTIONS } from '@/analytics/posthog.client';

const PostHogAnalyticsWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  if (!IS_POSTHOG_CONFIGURED) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={POSTHOG_PROJECT_API_KEY}
      options={POSTHOG_PROVIDER_OPTIONS}
    >
      {children}
    </PostHogProvider>
  );
};

export default PostHogAnalyticsWrapper;
